module.exports = __webpack_public_path__ + "static/media/calendar.18b69a80.png";